import {
  ActivityChangeOptions,
  ActivityTagItem,
  createActivityChangeExtension,
} from '@spotify/plugin-confidence-activity-react';

const STATE_LABELS: Record<string, string> = {
  draft: 'Draft',
  active: 'Active',
  live: 'Live',
  ended: 'Ended',
  archived: 'Archived',
};

const getStateLabel = (value: unknown): string => {
  if (typeof value === 'string') {
    return STATE_LABELS[value] ?? value;
  }
  return 'Unknown';
};

const getActionTitle = (oldState: unknown, newState: unknown): string => {
  const newStr = typeof newState === 'string' ? newState : '';

  switch (newStr) {
    case 'active':
    case 'live':
      return 'Launched experiment';
    case 'ended':
      return 'Ended experiment';
    case 'archived':
      return 'Archived';
    default:
      return `Changed state from ${getStateLabel(oldState)} to ${getStateLabel(newState)}`;
  }
};

const StateChangeRender = ({ change }: ActivityChangeOptions) => {
  return (
    <ActivityTagItem
      tagLabel="State"
      oldValue={getStateLabel(change.oldValue)}
      newValue={getStateLabel(change.newValue)}
    />
  );
};

export const STATE_CHANGE_EXTENSION = createActivityChangeExtension({
  id: 'state-change',
  priority: 10,
  predicate: ({ change }) => change.fieldPath === '/state',
  title: change => getActionTitle(change.oldValue, change.newValue),
  render: StateChangeRender,
  values: change => ({
    oldValue: { state: change.oldValue },
    newValue: { state: change.newValue },
  }),
});
